<template>
  <main>
    <div class="container text-left my-2">
      <form class="row mb-2" @submit.prevent="initSearch('s', searchInput)">
        <div class="col form-group">
          <h3 class="mb-1">Hae varustetta</h3>
          <input type="text" class="form-control" id="searchAccessory" placeholder="Nimellä, avainsanalla tai koodilla" autofocus v-model="searchInput">
        </div>
      </form>

      <!-- Show Bootstrap spinner until data is fetched -->
      <div v-if="!models || !groups" class="text-center pt-3">
        <div class="spinner-border text-red" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <!--
      <div class="row mb-2">
        <div class="col-12 mb-1">
          <h3>Yleisiä hakuja</h3>
        </div>
        <div class="col-12">
          <span class="badge badge-pill p-1 mr-1 mb-1 bg-cyan text-white">RAV4 hybrid tekstiilimatto</span>
          <span class="badge badge-pill p-1 mr-1 mb-1 bg-cyan text-white">Auris TS Webasto tehoakku</span>
          <span class="badge badge-pill p-1 mr-1 mb-1 bg-cyan text-white">Avensis suojamatto</span>
          <span class="badge badge-pill p-1 mr-1 mb-1 bg-cyan text-white">Pyöräteline</span>
          <span class="badge badge-pill p-1 mr-1 mb-1 bg-cyan text-white">Corolla Podium</span>
          <span class="badge badge-pill p-1 mr-1 mb-1 bg-cyan text-white">Pyöräteline</span>
          <span class="badge badge-pill p-1 mr-1 mb-1 bg-cyan text-white">C-HR vetokoukku </span>
          <span class="badge badge-pill p-1 mr-1 mb-1 bg-cyan text-white">Hilux kromi</span>
          <span class="badge badge-pill p-1 mr-1 mb-1 bg-cyan text-white">C-HR helma</span>
          <span class="badge badge-pill p-1 mr-1 mb-1 bg-cyan text-white">PZ41ABP00180T91</span>
          <span class="badge badge-pill p-1 mr-1 mb-1 bg-cyan text-white">T91 Avensis</span>
          <span class="badge badge-pill p-1 mr-1 mb-1 bg-cyan text-white">ZRENGASP01</span>
          <span class="badge badge-pill p-1 mr-1 mb-1 bg-cyan text-white">Kylki Proace</span>
        </div>
      </div>
      -->

      <div class="row mb-2" v-if="models">
        <div class="col-12">
          <h3>Näytä varusteet malleittain</h3>
        </div>
        <div v-for="model in models" :key="model.name" class="col-12 col-sm-6 col-md-4 col-lg-3">
          <div class="modelrange cursor--pointer" @click="initSearch('m', model.model_key)">
            <img :src="'https://lib.toyota.fi/cars/grid/' + model.model_key.toLowerCase() + '_@2x.png'" :alt="model.name">
            <div class="mt-1">
              <strong class="mt-2">{{model.name}}</strong>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-2" v-if="groups">
        <div class="col-12 mb-2">
          <h3>Näytä varusteet tuoteryhmittäin</h3>
        </div>
        <div class="col-12">
          <span v-for="group in groups" :key="group" class="badge badge-pill p-1 mr-1 mb-1 bg-indigo text-white cursor--pointer" @click="initSearch('g', group)">
            {{group}}
          </span>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'index',

  data () {
    return {
      searchInput: null
    }
  },

  computed: {
    ...mapGetters({
      models: 'getModels',
      groups: 'getGroups'
    })
  },

  mounted () {
    this.$store.dispatch('fetchModels')
    this.$store.dispatch('fetchGroups')
    // fetch and cache data before it is needed…
    this.$store.dispatch('fetchAllAccessories')
    // this.$store.dispatch('fetchOptions')
    // this.$store.dispatch('fetchPacks')
  },

  methods: {
    initSearch: function (t, s) {
      /*
        t(ype) = dispatch search by keyword, model or group
        s = search string
      */
      const p = [t, s]
      this.logSearch(p)
      this.$store.dispatch('updateInitialSearch', p)
      this.$router.push('Haku')
    },

    // Log searches into file
    logSearch: function (p) {
      const date = new Date()
      const l = [p, date.toISOString().split('T')[0]].join(',')
      // console.log(l)
      axios
        .post(process.env.VUE_APP_PROD_PHP_BACKEND + '/search_log.php', l)
        .then(response => {
          console.log(response)
        })
        .catch(error => { console.log(error) })
    }
  }
}
</script>
